import { useMutation } from '@tanstack/react-query'
import { useAuth } from '../store/auth.store'

const API_URL = (import.meta.env.VITE_API_URL as string) || 'http://localhost:3000'

export interface UploadedAttachment {
  id: string
  url: string
  localPath: string
  filename: string
  mimeType: string
  size: number
}

export function useUploadAttachment() {
  const { token } = useAuth()

  return useMutation<UploadedAttachment, Error, File>({
    mutationFn: async (file: File) => {
      const formData = new FormData()
      formData.append('file', file)

      const res = await fetch(`${API_URL}/uploads/attachments`, {
        method: 'POST',
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
        body: formData,
      })

      if (!res.ok) {
        let msg = `Error ${res.status}`
        try {
          const data = await res.json()
          msg = data.message || msg
        } catch {}
        throw new Error(msg)
      }
      return res.json()
    },
  })
}
